import { useTranslations } from "../../hooks/useTranslations";

interface QuickSearchFormProps {
	query: string;
	searchPageUrl: string;
	onChange: (query: string) => void;
	onFocus: () => void;
}

export default function QuickSearchForm({
	query,
	searchPageUrl,
	onChange,
	onFocus,
}: QuickSearchFormProps) {
	const t = useTranslations();

	return (
		<form
			action={searchPageUrl}
			method="get"
			className="grid w-full min-w-[12.5rem] grid-cols-1 lg:max-w-[25rem]"
		>
			<input
				type="search"
				name="q"
				value={query}
				className="menu-open:bg-white menu-open:text-dark-grey menu-open:placeholder:text-dark-grey transparent-header-scrolled:bg-white transparent-header:text-white transparent-header:placeholder:text-white transparent-header-scrolled:text-dark-grey transparent-header-scrolled:placeholder:text-dark-grey border-earth-50 placeholder:text-dark-grey col-start-1 row-start-1 block w-full rounded-full border-1 bg-transparent py-1.5 pr-10 text-base sm:pl-3"
				placeholder={t.search}
				aria-label={t.search}
				onChange={({ currentTarget }) => {
					onChange(currentTarget.value);
				}}
				onFocus={onFocus}
			/>
			<svg
				className="menu-open:text-dark-grey transparent-header-scrolled:text-dark-grey transparent-header:text-white text-dark-grey pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end"
				viewBox="0 0 20 20"
				fill="currentColor"
				aria-hidden="true"
				data-slot="icon"
			>
				<path
					fillRule="evenodd"
					d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
					clipRule="evenodd"
				/>
			</svg>
		</form>
	);
}
